<template>
  <div class="row">
    <div class="col-lg-2 p-0 bg-cx2 d-none d-lg-block">
      <status-menu :statuses="statuses" @select-status="onSelectStatus" @refresh="onInvoicesUpdated"></status-menu>
    </div>
    <div class="col-lg-10 p-0 bg-white  d-none d-lg-block">
      <invoice-list
        class="invoice-list"
        :invoices="invoices"
        :selected-status="selectedStatus"
        @select-invoice="onSelectInvoice"
        @invoices-updated="onInvoicesUpdated"
      >
      </invoice-list>
    </div>
  </div>
</template>

<script>
import api from '@/api.js'
import store from '@/stores/invoices.js'
import countBy from 'lodash/countBy'
import StatusMenu from '@/components/invoices/StatusMenu.vue'
import InvoiceList from '@/components/invoices/InvoiceList.vue'
import find from 'lodash/find'

export default {

  components: {
    StatusMenu,
    InvoiceList,
  },
 
  created: function() {
    api.get('/invoices').then(res => {
      store.setInvoices(res.data.invoices)
    })

    api.get('/invoices/statuses').then(res => {
      store.setStatuses(res.data.statuses)
    })
  },

  computed: {
    invoices() {
      if (!this.selectedStatus.id) {
        return store.state.invoices
      }

      return store.state.invoices.filter((invoice) => {
        if(invoice.status.id == this.selectedStatus.id) {
          return true
        }
      })
    },

    invoice() {
      return find(store.state.invoices, { id: parseInt(this.$route.params.id) }) || {}
    },

    selectedStatus() {
      return find(store.state.statuses, { slug: this.$route.params.status }) || {}
    },

    statuses() {
      const counts = countBy(store.state.invoices, 'status_id')
      
      return store.state.statuses.map(status => {
        status.ct = counts[status.id]
        status.active = status.id == this.selectedStatus.id
        return status
      })
    },
  },

  methods: {
    onInvoicesUpdated() {
      api.get('/invoices').then(res => {
        store.setInvoices(res.data.invoices)
      })

      api.get('/invoices/statuses').then(res => {
        store.setStatuses(res.data.statuses)
      })      
    },

    onSelectInvoice(invoice) {
      store.setInvoice(invoice)
    },

    onSelectStatus(status) {
      this.selectedStatus = status
      this.onSelectInvoice({})
    }
  },
}

</script>

<style scoped>
.invoice-list {
  height: calc(100vh - 48px);
  overflow-y: auto;
}

</style>